import "react-app-polyfill/ie9";
import 'lib-flexible/flexible';
import 'core-js/stable';
import 'whatwg-fetch';

import ReactDOM from "react-dom";
import Entry from "./entry";
import Stats from "./utils/bridgeTool/Stats";
import ActivityBridge from "./utils/bridgeTool/ActivityBridge";

import "./assets/index.scss";
import "./assets/reset.scss";

if (process.env.REACT_APP_NODE_ENV_2 === 'test' || process.env.NODE_ENV === 'development' ) {
  const isMobile = ActivityBridge.isMobile();
  if (isMobile) {
    const VConsole = require('vconsole');
    const vConsole = new VConsole();
  }
}

window.Tongji = new Stats({
  dataSource: "mail",
  interval: 1000,
  config: {
    application: "hd_2022WorkingHard_e07db6545ce6ae86",
    appVersion: "1.0.0",
    uid: "",
  },
});

// 防止页面自动滚动
if (window.history.scrollRestoration) {
  window.history.scrollRestoration = 'manual';
}

ReactDOM.render(<Entry />, document.getElementById("root"));

